module.exports = __webpack_public_path__ + "img/20180815_150119_052.61420f4e.jpg";